<template>
  <el-dialog
    v-el-dialog-drag
    show-close
    :visible.sync="visible"
    width="600px"
    title="生成账单"
    :close-on-click-modal="false"
    :before-close="() => close()"
  >
    <el-form
      ref="form"
      :model="formData"
      label-position="left"
      label-width="110px"
      inline-message
    >
      <el-row>
        <el-form-item label="客户">
          <dict-select
            filterable
            v-model="formData.custCodeList"
            url="/master/customer/info/select"
            placeholder="请选择客户"
            clearable
            multiple
          ></dict-select>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="订单创建时间">
          <el-col :span="11">
            <el-date-picker
              v-model="formData.beginCreateTime"
              type="date"
              size="small"
              value-format="yyyy-MM-dd"
              placeholder="请选择创建时间"
              style="width: 100%"
            >
            </el-date-picker>
          </el-col>
          <el-col class="line" :span="2">-</el-col>
          <el-col :span="11">
            <el-date-picker
              v-model="formData.endCreateTime"
              type="date"
              size="small"
              value-format="yyyy-MM-dd"
              placeholder="请选择创建时间"
              style="width: 100%"
            >
            </el-date-picker>
          </el-col>
        </el-form-item>
      </el-row>
    </el-form>
    <span slot="footer">
      <el-button size="small" @click="close()">取消</el-button>
      <el-button type="primary" size="small" @click="confirmGener()">
        确认生成
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  props: {
    visible: {type: Boolean, default: false},
  },
  data() {
    return {
      formData: {
        custCodeList: [],
        beginCreateTime: '',
        endCreateTime: '',
      },
    }
  },
  methods: {
    async confirmGener() {
      if (!this.checkData()) return
      const loadingInstance = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      this.$api
        .finIncomeFreightGenerateBillApi(this.formData)
        .then((res) => {
          loadingInstance.close()
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'success',
          })
          this.$emit('reload')
          this.close()
        })
        .catch(() => {
          loadingInstance.close()
        })
    },
    checkData() {
      if (
        this.formData.custCodeList.length <= 0 ||
        !this.formData.beginCreateTime ||
        !this.formData.endCreateTime
      ) {
        this.$message({
          showClose: true,
          message: '请选择需要生成账单的客户和时间段！',
          type: 'warning',
        })
        return false
      }
      return true
    },
    close() {
      this.$emit('close')
      this.$emit('update:visible', false)
    },
  },
}
</script>
<style lang="scss" scoped>
.line {
  text-align: center;
}
</style>
